export const GlobalColors = {
  primaryColor: '#00A8CC',
  secondaryColor: '#F57C00',
  backgroundColor: '#ECEFF1',
  textColor: '#263238',
  secondaryTextColor: '#607D8B'
}